import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.selectedRow = SELECTED_ROW();
		state.oldSelectedRow = SELECTED_ROW();

		state.isPqyUser = false;
		state.isNew = '';

		state.resultList = [];
		state.fileNames = [];

		state.useYnList = [];
		state.lgrpList = [];
		state.sgrpList = [];
		state.tymaList = [];
		state.ipnWayList = [];
		state.utmList = [];
		state.icrtList = [];
		state.sgrpAllList = [];
	},
	[types.ROW_INIT]: state => {
		state.selectedRow = SELECTED_ROW();
		state.sgrpList = [];
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.SELECTED_ROW]: (state, { key, value }) => {
		state.selectedRow[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	}
};
